import React, { useContext, useEffect, useState, useRef } from 'react';
import { Row, Col, Table, Spinner, Form, InputGroup, Button } from 'react-bootstrap';
import ReactToPrint from "react-to-print";
import generatePDF from 'react-to-pdf';
import { AppContext } from '../App';


export const CustomerWalletReport = () => {
    const { postCall, getDate, setGetLoad, getLoad, downloadExcel } = useContext(AppContext);
    const [dateRange, setDateRange] = useState('');
    const tableRef = useRef(null);
    const [report, setReport] = useState();
    const fetchReport = (start, end) => {
        if (start !== "" && end !== "") {
            setGetLoad(true);
            postCall('api/bnr/get/wallet/report/', { start_date: start, end_date: end }).then(res => {
                setReport(res.data);
                setDateRange(`customer_wallet_report_from_${start}_to_${end}`);
                setGetLoad(false);
            }).catch(err => {
                setGetLoad(false);
            });
        }
    }
    const getReport = (e) => {
        e.preventDefault();
        let start = e.target.start.value;
        let end = e.target.end.value;
        fetchReport(start, end);
    }
    const initialFetchDone = useRef(false);
    useEffect(() => {
        if (!initialFetchDone.current) {
            fetchReport(getDate(), getDate());
            initialFetchDone.current = true;
        }
    }, []);
    const formatExcel = () => {
        if (report !== undefined) {
            let data = [];
            Object.keys(report).map(b_val => {
                let paymentsString = "";
                if (report[b_val].payments !== undefined && Object.keys(report[b_val].payments).length > 0) {
                    Object.keys(report[b_val].payments).forEach(p_key => {
                        const payment = report[b_val].payments[p_key];
                        paymentsString += `${payment.name}: ${parseFloat(payment.amount).toFixed(2)}, `;
                    });
                }
                data.push({
                    'Date': report[b_val].date + ' ' + report[b_val].time,
                    'Customer': report[b_val].customer_name + ' ' + report[b_val].customer_phone,
                    'Staff': report[b_val].user,
                    'Payments': paymentsString,
                    'Transaction Type': report[b_val].transaction_type,
                    'Amount': report[b_val].amount
                });
            });
            return data;
        }
    }

    return (
        <div className='container-fluid'>
            <div className='grid4by6 align-items-center justify-content-between p-2 bgp br-3 mb-3' >
                <div className='px-2'>
                    {
                        getLoad ? (
                            <span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>
                        ) : (
                            <span className='text-white' >Customer Wallet Report</span>
                        )
                    }
                </div>
                <Form onSubmit={getReport} >
                    <Row>
                        <Col xs={12} sm={4} md={4} >
                            <InputGroup className="br-3">
                                <InputGroup.Text className="br-3" id="inputGroup-sizing-default">From</InputGroup.Text>
                                <Form.Control name="start" type="date" defaultValue={getDate()} className="br-3" />
                            </InputGroup>
                        </Col>
                        <Col xs={12} sm={4} md={4} >
                            <InputGroup className="br-3">
                                <InputGroup.Text className="br-3" id="inputGroup-sizing-default">To</InputGroup.Text>
                                <Form.Control name="end" type="date" defaultValue={getDate()} className="br-3" />
                            </InputGroup>
                        </Col>
                        <Col xs={12} sm={4} md={4} className="d-grid" >
                            <Button type="submit" className="btn-t1-r br-3" >Get Report</Button>
                        </Col>
                    </Row>
                </Form>
            </div>
            {
                report !== undefined ? (
                    <div className='d-flex justify-content-end align-items-center mb-2 gap-2' >
                        <span>Download</span>
                        <Button className="br-1" onClick={() => {
                            downloadExcel(formatExcel(), `${dateRange}.xlsx`);
                        }} size='sm' variant='success' ><i className='bi bi-download' ></i> Excel</Button>
                        <Button onClick={() => {
                            generatePDF(tableRef, { filename: `${dateRange}.pdf` });
                        }} size='sm' className='br-1' variant='success' ><i className='bi bi-download' ></i> Pdf</Button>
                        <ReactToPrint
                            trigger={() => <Button className='br-1' variant='success' size='sm'><i className="bi bi-printer"></i> Print</Button>}
                            content={() => tableRef.current}
                        />
                    </div>
                ) : null
            }
            <div ref={tableRef}>
                {

                    report !== undefined && Object.keys(report).length > 0 ? (
                        <Table bordered className="tbl-bg-blue" >
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Customer</th>
                                    <th>Staff</th>
                                    <th className='text-end' >Payments</th>
                                    <th className="text-end" >Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    Object.keys(report).map((item, i) => (
                                        <tr key={i} >
                                            <td>
                                                <div className='d-grid'>
                                                    <span className='tp2' >{report[item].date}</span>
                                                    <span className='tp2 f14' >{report[item].time}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='d-grid'>
                                                    <span className='tp2' >{report[item].customer_name}</span>
                                                    <span className='tp2 f14' >{report[item].customer_phone}</span>
                                                </div>
                                            </td>
                                            <td>{report[item].user}</td>
                                            <td>
                                                {
                                                    report[item].payments !== undefined && Object.keys(report[item].payments).length > 0 ? (
                                                        Object.keys(report[item].payments).map((item2, i2) => (
                                                            <div className='grid8by2 align-items-center justify-content-between bdrb2 mb-1 px-1' key={`xx_${i2}`} >
                                                                <span className='tp2' >{report[item].payments[item2].name}</span>
                                                                <div className='d-flex justify-content-end' >
                                                                    <span className='tp2' >{parseFloat(report[item].payments[item2].amount).toFixed(2)}</span>
                                                                </div>
                                                            </div>
                                                        ))
                                                    ) : null
                                                }
                                            </td>
                                            <td className="text-end" >
                                                {
                                                    report[item].transaction_type === 'debit' ? (
                                                        <span className="text-success" >+{parseFloat(report[item].amount).toFixed(2)}</span>
                                                    ) : (
                                                        <span className="text-danger" >-{parseFloat(report[item].amount).toFixed(2)}</span>
                                                    )
                                                }
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </Table>
                    ) : ''
                }
            </div>

        </div>
    )
}